import { render } from "./LoginHandler.vue?vue&type=template&id=5c18673f"
import script from "./LoginHandler.vue?vue&type=script&lang=js"
export * from "./LoginHandler.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rswenson/code/arch/surfacing/src/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__